'use client';

import { SuiProvider, type SuiProviderProps } from '@hrworks/sui-core/SuiProvider';

import { EmotionCacheProvider } from '../EmotionCacheProvider/EmotionCacheProvider';

export const SuiNextJsProvider = (props: SuiProviderProps) => (
  <EmotionCacheProvider>
    <SuiProvider {...props} />
  </EmotionCacheProvider>
);
